import type { MasterData } from 'types/masterData'
import { isBot } from 'utils/isBot/IsBot'
import type { SessionCacheStorage } from '../types/session'
import { getSessionCacheStorage } from './cacheStorage/getSessionCacheStorage'

export const getSessionCache = async (
	masterData: MasterData
): Promise<SessionCacheStorage | null> => {
	try {
		if (isBot()) {
			return null
		}
		const sessionCacheStorage = await getSessionCacheStorage(masterData)

		if (sessionCacheStorage) {
			return sessionCacheStorage
		}
	} catch (e) {
		console.error('Error getting session from cache storage', e)
	}

	return null
}
